export default (groups = []) => {
  const user = JSON.parse(localStorage.getItem('user'))

  if (user) {
    return user.groups.some(el => groups.includes(el))
  }
  return false
}
